import TextareaInput from './TextareaInput.vue';

export default TextareaInput;
